import { ReactNode, useEffect, useMemo, useState } from "react";
import { AuthorizationContext } from "../AuthContext";
import { SingletonRefreshClient } from "../../Api/SingletonRefreshClient";
import { Authorized } from "../../Api/GetAuthedClientNonHook";
import { AuthRycApiClient, MeResponse } from "../../Api/ApiServer";
import { RycIsProjectModule } from "../../Enums/RycIsProjectModule";
import { ProjectContext } from "../ProjectContext";

interface ProjectProviderProps {
    children: ReactNode;
}
const ProjectProvider: React.FC<ProjectProviderProps> = ({ children }) => {
    const [currentModule, setCurrentModule] = useState<RycIsProjectModule>(RycIsProjectModule.None);
    const [menuButtons, setMenuButtons] = useState<ReactNode | null>(null);
    const moduleName = useMemo(() => {
        switch (currentModule) {
            case RycIsProjectModule.Budget:
                return 'Rozpočet';
            case RycIsProjectModule.Detail:
                return 'Detail';
            case RycIsProjectModule.Files:
                return 'Dokumenty';
            case RycIsProjectModule.Viewer:
                return 'Model';
            default:
                return '';
        }
    }, [currentModule]);


    return (
        <ProjectContext.Provider value={{ currentModule, setCurrentModule, setMenuButtons, menuButtons, moduleName }
        }>
            {children}
        </ProjectContext.Provider>
    );
};
export default ProjectProvider;